import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './PageHeader.css';

const PageHeader = ({ title, subtitle }) => {
  const { isMarathi } = useLanguage();

  return (
    <div className="page-header">
      <h1 className="page-title">
        {isMarathi() ? title.marathi : title.english}
      </h1>
      <p className="page-subtitle">
        {isMarathi() ? subtitle.marathi : subtitle.english}
      </p>
    </div>
  );
};

export default PageHeader;
